module.exports = __webpack_public_path__ + "img/15000.41ab9cb8.jpg";